import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { modalElement: String, onConnect: Boolean }
  }

  connect() {
    if (this.onConnectValue) {
      this.show()
    }
  }

  show() {
    new bootstrap.Modal(this.modalElementValue).show()
  }

  hide() {
    const modalElement = document.querySelector(this.modalElementValue)
    const modalInstance = bootstrap.Modal.getInstance(modalElement)
    if (modalInstance) {
      modalInstance.hide()
    }
    // Clean up any remaining backdrops
    document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove())
  }
}
